import type { ReactNode } from 'react'
import './card-grid.css'

/**
 * Titled cards side by side — an overview, where each card summarizes one
 * place and opens it.
 *
 * As many columns as the column it was handed holds at a readable card width,
 * one where it holds one; never a window width. A row's cards share its
 * height, so their edges line up across the row.
 */
export function CardGrid({ children }: { children: ReactNode }) {
  return <div className="card-grid">{children}</div>
}
